module.exports = __webpack_public_path__ + "static/media/Settings.a9040b74.png";